//=====================================================
//　Context宣言
//=====================================================
import { createContext } from "react";
import { IFUseAuth } from "./UseAuth";
import { IFUseClinicInfo, InitDataClinicInfo } from "./UseClinicInfo";
import { IFUseClinicSystemInfo, InitDataClinicSystemInfo } from "./UseClinicSystemInfo";
import { IFUseNewReservation, InitDataNewReservation } from "./UseNewReservation";
import { IFUsePatientInfo, InitDataPatientInfo } from "./UsePatientInfo";
import { IFUsePatientDetailInfo, InitDataPatientDetailInfo } from "./UsePatientDetailInfo";
import { IFUseSystemErr } from "./UseSystemErr";
import { LoginStatusType } from "../utils/ConstCommon"

//医院情報Context
export const CtxClinicInfo = createContext<IFUseClinicInfo>({
    data: InitDataClinicInfo,
});

//医院システム情報Context
export const CtxClinicSystemInfo = createContext<IFUseClinicSystemInfo>({
    data: InitDataClinicSystemInfo
});

//患者情報Context
export const CtxPatientInfo = createContext<IFUsePatientInfo>({
    data: InitDataPatientInfo,
    getData: function():string{return ""},
    update: function(){},
    clear : function(){},
});

//ユーザ認証Context
export const CtxAuth = createContext<IFUseAuth>({
    login: function(){},
    linelogin: function(){},
    logout: function(){},
    getToken: function():string{return ""},
    getPatientNo: function():string{return ""},
    checkExpiresIn: function():LoginStatusType{return LoginStatusType.LogOut},
    isLoggedIn: function():boolean{return false},
});

//新規予約情報Context
export const CtxNewReservation = createContext<IFUseNewReservation>({
    type: -1,
    data: InitDataNewReservation,
    create: function(){},
    update: function(){},
});

//患者詳細情報Context
export const CtxPatientDetailInfo = createContext<IFUsePatientDetailInfo>({
    data: InitDataPatientDetailInfo,
    update: function(){},
});

//システムエラー情報Context
export const CtxSystemErr = createContext<IFUseSystemErr>({
    errmess: "",
    setErrmess: function(){},
    setHistory: function(){},
});
